import { createRoot } from "react-dom/client";

import "./index.css";
import App from "./view/App";
import { BrowserRouter } from "react-router-dom";
import { AppContextProvider } from "./context/context";
import Modal from "react-modal";
import { Provider } from "react-redux";
import store from "./redux/store";
const root = document.getElementById("root");
Modal.setAppElement(root);
createRoot(root).render(
  <Provider store={store}>
    <BrowserRouter>
      <AppContextProvider>
        <App />
      </AppContextProvider>
    </BrowserRouter>
  </Provider>
);
//test commit
